<template>
    <div
        id="notifications_div"
        :class="showNotificationList ? 'active' : ''"
        v-click-outside="onClickOutsideNotification"
    >
        <div
            class="box__icon--notification"
            style="cursor: pointer"
            @click="onClickShowNotificationList"
        >
            <v-badge
                class="header-badge"
                color="#f59534"
                overlap
                offset-x="16"
                offset-y="16"
                :value="totalUnreadMessages > 0"
                :content="badgeCount(totalUnreadMessages)"
            >
                <div
                    id="icon_notification"
                    class="has--notification"
                    :class="checkRouteModule ? 'bo-class' : 'normal-class'"
                >
                    <img
                        :src="
                            checkRouteModule
                                ? '/images/_SVGs/notificacoes_normal-bo.svg'
                                : '/images/_SVGs/notificacoes_normal.svg'
                        "
                        onload="SVGInject(this)"
                        width="100%"
                    />
                </div>
            </v-badge>
        </div>

        <v-slide-y-transition>
            <v-card
                class="drawer-card container__list arrow_card"
                v-show="showNotificationList"
                :style="notificationListStyle"
                style="z-index: 1"
            >
                <v-container>
                    <v-row justify="space-between" class="group-btns">
                        <v-col
                            cols="auto"
                            v-for="(tab, index) in tabs"
                            :key="index"
                        >
                            <v-btn
                                @click="activeTab = index"
                                :class="activeTab === index ? 'active' : ''"
                            >
                                {{ tab }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

                <div
                    v-for="(tab, tabIndex) in tabs"
                    :key="tabIndex"
                    v-show="activeTab === tabIndex"
                >
                    <div
                        class="header d-flex"
                        style="
                            border-bottom: 1px solid #9e9d9d;
                            position: relative;
                            z-index: 2;
                            margin-bottom: 10px;
                        "
                    >
                        <v-col
                            cols="12"
                            sm="12"
                            class="d-flex justify-end align-items-start p-0 pr-3"
                            v-if="showRemoveCheckBoxes"
                        >
                            <v-checkbox
                                class="checkbox-select-all"
                                reverse
                                v-model="selectAllToRemove"
                                hide-details
                                style="margin-bottom: 5px"
                            ></v-checkbox>
                        </v-col>
                    </div>
                    <div
                        class="body-notification"
                        :style="{
                            maxHeight: showRemoveCheckBoxes ? '385px' : '420px',
                            minHeight: showRemoveCheckBoxes ? '385px' : '420px',
                        }"
                    >
                        <div
                            v-if="getFilteredNotifications(tabIndex).length"
                            class="d-flex flex-column"
                        >
                            <template
                                v-for="(
                                    notification, index
                                ) in getFilteredNotifications(tabIndex)"
                            >
                                <v-col
                                    class="d-flex flex-row p-0 row---div--notification"
                                    :key="index"
                                    v-if="
                                        seeAllNotifications ||
                                        (!seeAllNotifications &&
                                            !notification.isRead)
                                    "
                                    @click="onClickNotification([notification])"
                                    style="cursor: pointer"
                                >
                                    <v-col
                                        :cols="12"
                                        class="d-flex align-items-center"
                                        v-if="
                                            seeAllNotifications ||
                                            (!seeAllNotifications &&
                                                !notification.isRead)
                                        "
                                    >
                                        <template
                                            v-if="
                                                !notification.seeMoreAboutMessage
                                            "
                                        >
                                            <div
                                                class="notification-image"
                                                v-if="
                                                    notification.notificationIconURL
                                                "
                                            >
                                                <img
                                                    :src="
                                                        notification.notificationIconURL
                                                    "
                                                    alt="Notification Image"
                                                />
                                            </div>
                                            <div class="notification-content">
                                                <div
                                                    class="body-msg"
                                                    :style="
                                                        notification.isRead
                                                            ? ''
                                                            : 'color: var(--v-primary-base)'
                                                    "
                                                    v-html="
                                                        $helpers.getSafeMarkdown(
                                                            notification.title
                                                        )
                                                    "
                                                />
                                                <div
                                                    class="body-msg mt-2"
                                                    style="
                                                        font-weight: normal;
                                                        white-space: pre-line;
                                                    "
                                                    v-html="
                                                        $helpers.getSafeMarkdown(
                                                            notification.bodyText
                                                        )
                                                    "
                                                />
                                                <p class="date-msg">
                                                    <span
                                                        v-if="activeTab === 0"
                                                    >
                                                        {{
                                                            notification.initialDatetime
                                                                | formatDateWithMonthAndTime
                                                        }}
                                                    </span>
                                                    <span v-else>
                                                        {{
                                                            notification.creationDatetime
                                                                | formatDateWithMonth
                                                        }}
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                    </v-col>
                                    <v-col
                                        class="notification-container"
                                        :class="
                                            notification.seeMoreAboutMessage
                                                ? ''
                                                : 'align-items-center'
                                        "
                                    >
                                        <div v-if="showRemoveCheckBoxes">
                                            <v-checkbox
                                                class="checkbox-see-all"
                                                @click.stop
                                                v-model="
                                                    notification.checkToRemove
                                                "
                                                hide-details
                                            ></v-checkbox>
                                        </div>
                                    </v-col>
                                </v-col>
                            </template>
                        </div>
                        <div
                            v-else
                            class="d-flex flex-column"
                            style="text-align: center"
                        >
                            <v-col
                                class="align-content-center"
                                :style="{
                                    minHeight: showRemoveCheckBoxes
                                        ? '320px'
                                        : '420px',
                                }"
                            >
                                <span>{{ $t("zero-notifications") }}</span>
                            </v-col>
                        </div>
                    </div>
                    <v-card-actions class="actions-container">
                        <div class="d-flex flex-column" style="width: 100%">
                            <div
                                class="d-flex"
                                style="
                                    place-content: center;
                                    justify-content: space-between;
                                "
                            >
                                <v-col
                                    cols="12"
                                    sm="4"
                                    class="d-flex justify-start"
                                >
                                    <v-btn
                                        @click="onClickPreviousPage(tabIndex)"
                                        class="primary-button"
                                        :loading="loadingButtonPrevious"
                                        outlined
                                        rounded
                                        text
                                        v-if="
                                            stores[getStoreKey(tabIndex)]
                                                .currentPage > 1
                                        "
                                    >
                                        <img
                                            src="/images/_SVGs/back-arrow.svg"
                                            onload="SVGInject(this)"
                                            alt="next-button"
                                            style="transform: rotate(360deg)"
                                        />
                                        <span class="span-btn-modal">{{
                                            $t("back")
                                        }}</span>
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    class="d-flex justify-end"
                                >
                                    <v-btn
                                        @click="onClickNextPage(tabIndex)"
                                        class="primary-button"
                                        :loading="loadingButtonNext"
                                        outlined
                                        rounded
                                        text
                                        v-if="
                                            stores[getStoreKey(tabIndex)]
                                                .totalPages > 1 &&
                                            stores[getStoreKey(tabIndex)]
                                                .currentPage !=
                                                stores[getStoreKey(tabIndex)]
                                                    .totalPages
                                        "
                                    >
                                        <span class="span-btn-modal">{{
                                            $t("next")
                                        }}</span>
                                        <img
                                            src="/images/_SVGs/back-arrow.svg"
                                            onload="SVGInject(this)"
                                            alt="next-button"
                                            style="transform: rotate(900deg)"
                                        />
                                    </v-btn>
                                </v-col>
                            </div>
                            <v-row class="pt-2">
                                <v-col
                                    cols="12"
                                    sm="6"
                                    class="d-flex justify-start align-items-start p-0 pr-3"
                                    v-if="
                                        getCurrentStore(activeTab).totalPages !=
                                        0
                                    "
                                >
                                    <v-checkbox
                                        v-if="!showRemoveCheckBoxes"
                                        class="checkbox-see-all"
                                        :disabled="
                                            loadingButtonNext ||
                                            loadingButtonPrevious
                                        "
                                        v-model="seeAllNotifications"
                                        :label="$t('see-all')"
                                        hide-details
                                    ></v-checkbox>
                                    <v-btn
                                        v-if="showRemoveCheckBoxes"
                                        @click="handleClickToRemoveSelection"
                                        text
                                        color="red"
                                        style="text-transform: capitalize"
                                    >
                                        {{
                                            $t("notifications.delete-selected")
                                        }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    class="d-flex justify-end align-items-start p-0 pr-3"
                                    v-if="
                                        !showRemoveCheckBoxes &&
                                        hasNotifications
                                    "
                                >
                                    <v-btn
                                        @click="handleClickToRemove"
                                        text
                                        color="red"
                                        style="text-transform: capitalize"
                                        >{{ $t("delete") }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    v-if="
                                        hasReadNotifications &&
                                        showRemoveCheckBoxes
                                    "
                                    cols="12"
                                    sm="6"
                                    class="d-flex justify-end align-items-start p-0 pr-3"
                                >
                                    <v-btn
                                        @click="openDeleteReadModal"
                                        text
                                        color="red"
                                        style="text-transform: capitalize"
                                    >
                                        {{ $t("notifications.delete-read") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="pt-2 align-center">
                                <v-col
                                    cols="12"
                                    sm="4"
                                    class="d-flex justify-start"
                                >
                                    <v-btn
                                        v-if="showRemoveCheckBoxes"
                                        @click="handleCancelRemoveCheckboxes"
                                        text
                                        style="text-transform: capitalize"
                                    >
                                        {{ $t("cancel") }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    class="d-flex justify-center"
                                >
                                    <span
                                        v-if="
                                            stores[getStoreKey(tabIndex)]
                                                .totalPages != 0
                                        "
                                    >
                                        {{
                                            stores[getStoreKey(tabIndex)]
                                                .currentPage
                                        }}
                                        /
                                        {{
                                            stores[getStoreKey(tabIndex)]
                                                .totalPages
                                        }}
                                    </span>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    class="d-flex justify-end"
                                ></v-col>
                            </v-row>
                        </div>
                    </v-card-actions>
                </div>
            </v-card>
        </v-slide-y-transition>

        <PopupNotification
            v-if="
                modalShowNotification &&
                modalShowNotification.length > 0 &&
                modalShowNotification[0].showPopup
            "
            :isPreview="false"
            :formNotification="modalShowNotification"
            @onCloseModal="onClosePreviewModal"
            @show-popup="watchShowPopup"
        />

        <base-modal
            v-model="modalDeleteRead.show"
            :title="$t('notifications.remove-read-title')"
            modal-width="500px"
            iconColor="warning"
            iconName="mdi-alert-outline"
            @watch-show-value="clickOutsideModalDeleteRead"
        >
            <template v-slot:modal-body>
                <span>
                    {{ $t("notifications.remove-read-confirmation") }}
                    <br />
                </span>
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn
                        text
                        class="danger-button mr-3"
                        @click="cancelModalDeleteRead"
                        style="text-transform: capitalize"
                    >
                        {{ $t("cancel") }}
                    </v-btn>
                    <v-btn
                        text
                        class="primary-button"
                        @click="removeReadNotifications"
                        style="text-transform: capitalize"
                    >
                        {{ $t("confirm") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {
    UserServicesChangeStatusNotification,
    UserServicesDeleteListNotification,
} from "@services/UserServices";
import mixinNotifications from "@mixins/b2b/notifications.js";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

const storeKeyToNotificationTypeId = {
    requestsAlerts: [3], // Pedido de peças
    communications: [1, 2], // Comunicações
};

export default {
    name: "NotificationComponent",
    mixins: [mixinNotifications],
    components: {
        BaseModal,
        PopupNotification: () =>
            import("@components/backoffice/notifications/PopupNotification"),
    },
    data() {
        return {
            showNotificationList: false,
            stores: {
                requestsAlerts: {
                    currentPage: 1,
                    pageSize: 6,
                    result: [],
                    totalPages: 1,
                    totalRecords: 2,
                },
                communications: {
                    currentPage: 1,
                    pageSize: 6,
                    result: [],
                    totalPages: 1,
                    totalRecords: 0,
                },
            },
            modalShowNotification: [
                {
                    bellTitle: "",
                    bodyText: "",
                    expiresDatetime: "",
                    image: "",
                    isRead: "",
                    notificationId: "",
                    showPopup: "",
                    showPreview: false,
                    title: "",
                    linkCTA: "",
                    embedUrl: "",
                },
            ],
            seeAllNotifications: true,
            loadingButtonNext: false,
            loadingButtonPrevious: false,
            modalDeleteRead: {
                show: false,
                isOpen: false,
            },
            activeTab: 0,
            showRemoveCheckBoxes: false,
            totalUnreadMessages: 0,
            allNotifications: [],
            previousUnreadCount: null,
            lastNotificationSoundAt: 0,
        };
    },
    computed: {
        checkRouteModule() {
            const str = this.$route.fullPath;
            return str.indexOf("backoffice") != -1;
        },
        notificationsList() {
            return this.$store.getters["notifications/getNotificationsState"];
        },
        hasNotifications() {
            const currentStore = this.getCurrentStore(this.activeTab);
            return currentStore.result && currentStore.result.length > 0;
        },
        hasReadNotifications() {
            const currentStore = this.getCurrentStore(this.activeTab);
            return currentStore.result.some(
                (notification) => notification.isRead
            );
        },
        tabs() {
            return [
                this.$t("notifications.request-manager"),
                this.$t("notifications.communication"),
            ];
        },
        selectAllToRemove: {
            get() {
                const storeKey = this.getStoreKey(this.activeTab);
                const notificationTypeIds =
                    storeKeyToNotificationTypeId[storeKey];
                const notificationsInStore = this.allNotifications.filter((n) =>
                    notificationTypeIds.includes(n.notificationTypeId)
                );
                return (
                    notificationsInStore.length > 0 &&
                    notificationsInStore.every((n) => n.checkToRemove)
                );
            },
            set(value) {
                const storeKey = this.getStoreKey(this.activeTab);
                const notificationTypeIds =
                    storeKeyToNotificationTypeId[storeKey];
                this.allNotifications.forEach((notification) => {
                    if (
                        notificationTypeIds.includes(
                            notification.notificationTypeId
                        )
                    ) {
                        notification.checkToRemove = value;
                    }
                });
            },
        },
        notificationListStyle() {
            return {
                marginLeft: this.checkRouteModule ? "-500px" : "-440px",
            };
        },
    },
    watch: {
        notificationsList: {
            handler: function (newValue) {
                if (newValue) {
                    this.distributeNotifications(newValue);
                }
            },
            deep: true,
            immediate: true,
        },
        activeTab(newVal, oldVal) {
            if (this.showRemoveCheckBoxes) {
                this.handleCancelRemoveCheckboxes();
            }
        },
    },
    methods: {
        badgeCount(count) {
            return count > 99 ? "99+" : `${count}`;
        },
        distributeNotifications(notificationData) {
            if (notificationData && notificationData.result) {
                this.allNotifications = notificationData.result.map((n) => ({
                    ...n,
                }));

                Object.keys(this.stores).forEach((storeKey) => {
                    const notificationTypeIds =
                        storeKeyToNotificationTypeId[storeKey];
                    const notificationsForStore = this.allNotifications.filter(
                        (n) =>
                            notificationTypeIds.includes(n.notificationTypeId)
                    );

                    const pageSize = this.stores[storeKey].pageSize;
                    const totalRecords = notificationsForStore.length;
                    const totalPages = Math.ceil(totalRecords / pageSize);

                    this.stores[storeKey].totalRecords = totalRecords;
                    this.stores[storeKey].totalPages = totalPages;

                    const currentPage = this.stores[storeKey].currentPage;
                    const startIndex = (currentPage - 1) * pageSize;
                    const endIndex = startIndex + pageSize;

                    this.stores[storeKey].result = notificationsForStore.slice(
                        startIndex,
                        endIndex
                    );
                });

                this.totalUnreadMessages = this.allNotifications.filter(
                    (n) => !n.isRead
                ).length;

                this.maybePlayNotificationSound(this.totalUnreadMessages);

                this.updateTabTitle(this.totalUnreadMessages);
            }
        },
        maybePlayNotificationSound(unreadCount) {
            const previous = this.previousUnreadCount;
            this.previousUnreadCount = unreadCount;

            if (previous === null || unreadCount <= previous) {
                return;
            }

            const now = Date.now();
            if (now - this.lastNotificationSoundAt < 3000) {
                return;
            }
            this.lastNotificationSoundAt = now;

            try {
                const AudioCtx = window.AudioContext || window.webkitAudioContext;
                if (!AudioCtx) {
                    return;
                }

                if (!this.$options.notificationAudioContext) {
                    this.$options.notificationAudioContext = new AudioCtx();
                }
                const ctx = this.$options.notificationAudioContext;
                if (ctx.state === "suspended") {
                    ctx.resume();
                }

                const master = ctx.createGain();
                master.gain.value = 0.9;
                master.connect(ctx.destination);

                const partials = [
                    { ratio: 1, gain: 1, decay: 1 },
                    { ratio: 2, gain: 0.3, decay: 0.5 },
                    { ratio: 3.01, gain: 0.09, decay: 0.25 },
                ];

                const playNote = (frequency, startAt, duration, peak) => {
                    partials.forEach((partial) => {
                        const oscillator = ctx.createOscillator();
                        const gain = ctx.createGain();
                        oscillator.type = "sine";
                        oscillator.frequency.value = frequency * partial.ratio;

                        const partialDuration = duration * partial.decay;

                        gain.gain.setValueAtTime(0.0001, startAt);
                        gain.gain.exponentialRampToValueAtTime(
                            peak * partial.gain,
                            startAt + 0.008
                        );
                        gain.gain.exponentialRampToValueAtTime(
                            0.0001,
                            startAt + partialDuration
                        );

                        oscillator.connect(gain);
                        gain.connect(master);
                        oscillator.start(startAt);
                        oscillator.stop(startAt + partialDuration);
                    });
                };

                const start = ctx.currentTime;
                playNote(880, start, 0.9, 0.09);
                playNote(1174.66, start + 0.13, 1.0, 0.085);
                playNote(1479.98, start + 0.26, 2.1, 0.075);
            } catch (e) {
            }
        },
        getFilteredNotifications(tabIndex) {
            const storeKey = this.getStoreKey(tabIndex);
            return this.stores[storeKey].result;
        },
        formatMarkdown(val) {
            return val.replace(new RegExp("\r?\n", "g"), "<br />");
        },
        onClickShowNotificationList() {
            const allowedTypes = [
                ...storeKeyToNotificationTypeId.requestsAlerts,
                ...storeKeyToNotificationTypeId.communications,
            ];

            const hasOnlyAllowedTypes = this.allNotifications.every((n) =>
                allowedTypes.includes(n.notificationTypeId)
            );

            if (hasOnlyAllowedTypes) {
                if (this.allNotifications.length === 0) {
                    this.activeTab = 0;
                } else {
                    const allCommunications = this.allNotifications.every((n) =>
                        storeKeyToNotificationTypeId.communications.includes(
                            n.notificationTypeId
                        )
                    );
                    const allRequestsAlerts = this.allNotifications.every((n) =>
                        storeKeyToNotificationTypeId.requestsAlerts.includes(
                            n.notificationTypeId
                        )
                    );

                    if (allCommunications) {
                        this.activeTab = 1;
                    } else if (allRequestsAlerts) {
                        this.activeTab = 0;
                    } else {
                        this.activeTab = 0;
                    }
                }
            } else {
                this.activeTab = 0;
            }

            this.showNotificationList = !this.showNotificationList;
        },
        onClickOutsideNotification() {
            if (!this.modalDeleteRead.isOpen) {
                this.showNotificationList = false;
            }
        },
        onClickNotification(notifications) {
            if (this.loadingButtonNext || this.loadingButtonPrevious) {
                return;
            }

            const notification = notifications[0];

            this.$analytics.notificationClicked({
                notification_id: notification.notificationId,
                notification_type_id: notification.notificationTypeId,
                title: notification.title,
                has_link_cta: !!notification.linkCTA,
                has_popup: !!notification.showPopup,
                was_unread: !notification.isRead,
                link_cta: notification.linkCTA || null,
            });

            if (this.activeTab === 0 && notification.linkCTA) {
                window.location.href = notification.linkCTA;
            } else if (this.activeTab === 0) {
                this.$router.push({ name: "request-manager-inbox" });
            } else if (notification.showPopup) {
                this.modalShowNotification = notifications;
                this.modalShowNotification.forEach(
                    (n) => (n.showPreview = true)
                );
            }

            if (!notification.isRead) {
                this.onClickChangeReadStatus(
                    notification.notificationId,
                    true,
                    false
                );
            }
        },
        onClosePreviewModal() {
            for (let i = 0; i < this.modalShowNotification.length; i++) {
                this.modalShowNotification[i].showPreview = false;
            }
        },
        onClickChangeReadStatus(notificationId, status, showList = true) {
            let body = { markRead: status };
            UserServicesChangeStatusNotification(notificationId, body)
                .catch((error) => {
                    console.error(
                        "Error in UserServicesChangeStatusNotification",
                        error
                    );
                })
                .finally(() => {
                    this.showNotificationList = showList;
                });
        },
        onClickNextPage(tabIndex) {
            const store = this.getCurrentStore(tabIndex);
            if (store.currentPage < store.totalPages) {
                store.currentPage += 1;
                this.distributeNotifications({ result: this.allNotifications });
            }
        },
        onClickPreviousPage(tabIndex) {
            const store = this.getCurrentStore(tabIndex);
            if (store.currentPage > 1) {
                store.currentPage -= 1;
                this.distributeNotifications({ result: this.allNotifications });
            }
        },
        updateNotificationsList() {
            this.getNotifications(
                () => {},
                () => {
                    this.distributeNotifications({
                        result: this.allNotifications,
                    });
                }
            );
        },
        watchShowPopup(value) {
            if (!value) {
                this.onClosePreviewModal();
            }
        },
        handleClickToRemove() {
            this.showRemoveCheckBoxes = true;
        },
        handleClickToRemoveSelection() {
            const storeKey = this.getStoreKey(this.activeTab);
            const notificationTypeIds = storeKeyToNotificationTypeId[storeKey];
            const notificationsToRemove = this.allNotifications.filter(
                (n) =>
                    notificationTypeIds.includes(n.notificationTypeId) &&
                    n.checkToRemove
            );
            const notificationIds = notificationsToRemove.map(
                (n) => n.notificationId
            );

            if (notificationIds.length === 0) {
                return;
            }

            UserServicesDeleteListNotification(notificationIds)
                .catch((error) => {
                    console.error("Error removing notifications", error);
                })
                .finally(() => {
                    this.showRemoveCheckBoxes = false;
                    this.modalDeleteRead.isOpen = false;
                    this.modalDeleteRead.show = false;
                });
        },
        handleCancelRemoveCheckboxes() {
            this.showRemoveCheckBoxes = false;
            const storeKey = this.getStoreKey(this.activeTab);
            const notificationTypeIds = storeKeyToNotificationTypeId[storeKey];
            this.allNotifications.forEach((notification) => {
                if (
                    notificationTypeIds.includes(
                        notification.notificationTypeId
                    )
                ) {
                    notification.checkToRemove = false;
                }
            });
        },
        getStoreKey(tabIndex) {
            const keys = ["requestsAlerts", "communications"];
            return keys[tabIndex];
        },
        getCurrentStore(tabIndex) {
            return this.stores[this.getStoreKey(tabIndex)];
        },
        openDeleteReadModal() {
            const currentStore = this.getCurrentStore(this.activeTab);
            const readNotifications = this.allNotifications.filter(
                (n) =>
                    n.isRead &&
                    storeKeyToNotificationTypeId[
                        this.getStoreKey(this.activeTab)
                    ].includes(n.notificationTypeId)
            );

            if (readNotifications.length === 0) {
                return;
            }
            this.modalDeleteRead.show = true;
            this.modalDeleteRead.isOpen = true;
        },
        clickOutsideModalDeleteRead(value) {
            if (!value) {
                this.modalDeleteRead.show = false;
            }
        },
        cancelModalDeleteRead() {
            this.modalDeleteRead.show = false;
            setTimeout(() => {
                this.modalDeleteRead.isOpen = false;
            }, 100);
        },
        removeReadNotifications() {
            this.modalDeleteRead.show = false;
            const storeKey = this.getStoreKey(this.activeTab);
            const notificationTypeIds = storeKeyToNotificationTypeId[storeKey];
            const readNotifications = this.allNotifications.filter(
                (n) =>
                    n.isRead &&
                    notificationTypeIds.includes(n.notificationTypeId)
            );
            const notificationIds = readNotifications.map(
                (n) => n.notificationId
            );

            if (notificationIds.length === 0) {
                return;
            }

            UserServicesDeleteListNotification(notificationIds)
                .catch((error) => {
                    console.error("Error removing read notifications", error);
                })
                .finally(() => {
                    this.modalDeleteRead.isOpen = false;
                    this.modalDeleteRead.show = false;
                });
        },
        async updateTabTitle(length) {
            const rawDomain = localStorage.getItem("@datadrive:domain");
            let parsedDomain = null;
            if (rawDomain) {
                try { parsedDomain = JSON.parse(rawDomain); } catch (_) { parsedDomain = null; }
            }
            const appName = (parsedDomain && parsedDomain.appName) || document.title || "";
            if (length > 0) {
                document.title = `(${length}) ${appName}`;
            } else {
                document.title = appName;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";

#notifications_div {
    .header-badge {
        display: block;
        margin-top: 0 !important;

        ::v-deep .v-badge__badge {
            font-family: Lato;
            font-size: 12px;
            transition: ease $animations-time-duration;
        }
    }

    .icon--notification {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: $grey-medium;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        &:hover {
            svg {
                path {
                    fill: var(--v-primary-lighten1);
                }
            }
        }

        &:hover,
        &:active {
            background: #006082 !important;

            svg {
                g {
                    g {
                        path {
                            fill: #006082 !important;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .has--notification.normal-class {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--v-primary-base) !important;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        svg {
            .st0 {
                fill: var(--v-primary-base) !important;
            }

            g {
                g {
                    path {
                        stroke: #fff !important;
                    }
                }
            }
        }

        &:hover,
        &.active {
            background: var(--v-primary-darken1) !important;

            svg {
                g {
                    g {
                        path {
                            fill: var(--v-primary-darken1) !important;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .has--notification.bo-class {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--v-primary-base) !important;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        svg {
            .st0x {
                fill: var(--v-primary-base) !important;
            }
        }

        &:hover,
        &.active {
            background: var(--v-primary-darken1) !important;

            svg {
                g {
                    g {
                        path {
                            fill: var(--v-primary-darken1) !important;
                        }
                    }
                }
            }
        }
    }

    .triangle {
        position: absolute;
        top: -30px;
        right: 0;
        width: 0;
        border-left: 30px solid transparent;
        border-bottom: 30px solid white;
        -webkit-filter: drop-shadow(5px -5px 10px #9e9d9d);
        filter: drop-shadow(0px 3px 10px black);
    }
    .square {
        background-color: white;
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 30px;
        z-index: 1;
    }

    .container__list {
        box-shadow: 0px 0px 10px #9e9d9d;
        padding: 0px 30px 0px 30px;
        top: 65px;
        background-color: $white;
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 620px;
        max-height: 670px;
        color: $grey-dark;
        height: 670px;
        border-radius: 10px 10px 10px 10px;

        .body-notification {
            cursor: pointer;
            overflow: auto;
            flex-grow: 1;
            overflow-y: auto;

            .span--title {
                font-weight: bold;
                font-size: 16px;
            }

            .span--isRead {
                color: #9e9d9d;
                float: right;

                &:hover {
                    color: var(--v-primary-base);
                }
            }

            .active-read {
                color: var(--v-primary-base);
            }

            .row---div--notification {
                position: relative;
                border-bottom: 1px solid #9e9d9d;
                padding: 0;
                display: flex;
                align-items: flex-start;

                &:hover {
                    /* border-left: 10px solid var(--v-primary-base); */
                    box-shadow: 0 1px 6px var(--v-primary-lighten2);
                }
            }

            .body-msg {
                font: normal normal bold 14px/18px Lato;
                letter-spacing: 0px;
                margin-bottom: 0px;
                max-width: 94%;
            }

            .date-msg {
                font: normal normal bold 10px/12px Lato;
                letter-spacing: 0px;
                margin-bottom: 0px;
            }

            .underline-msg {
                font: normal normal bold 10px/12px Lato;
                letter-spacing: 0px;
                color: var(--v-primary-base);

                &:hover {
                    text-decoration: underline;
                }
            }

            .notification-image {
                flex-shrink: 0;
                margin-right: 16px;
                width: 30px;
                height: 30px;
                overflow: hidden;
                align-content: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .notification-content {
                flex-grow: 1;
                max-width: calc(100% - 86px);
            }
        }

        .checkbox-see-all {
            &::v-deep label {
                margin-bottom: 0px !important;
            }
        }
    }

    .v-input--selection-controls {
        margin-top: 0px !important;
        padding-top: 4px;
    }

    .notification-title {
        border-radius: 12px;
        width: 107px;
        display: flex;
        justify-content: center;

        p {
            margin-top: 8px;
            color: #3e3c3d;
            font-size: 16px;
            font-weight: bold;
        }

        a {
            margin-top: 8px;
            font-size: 14px;
        }
    }

    .span-btn-modal {
        color: var(--v-primary-base);
        text-transform: capitalize;
        font-weight: bold;
    }

    .primary-button {
        border: 1px solid var(--v-primary-base);

        font-weight: 600;
        color: var(--v-primary-base);
        border-radius: 43px;
        background: transparent !important;

        &:hover {
            background: var(--v-primary-base) !important;
            color: #fff;

            .span-btn-modal {
                color: #fff;
            }

            &::v-deep svg {
                g {
                    g {
                        g {
                            g {
                                path {
                                    stroke: white !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 426px) {
        .container__list {
            margin-left: 0px;
            left: 0;
            right: 0;
            top: 70px;
        }
    }

    .fix-top {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 6px;
        padding-bottom: 0;
        flex-direction: row;
        height: 30px;

        &:hover {
        }
    }

    .read-message {
        margin-top: 6px;
        padding-right: 0;
        padding-bottom: 0;
        text-align: end;
    }

    .notification-container {
        display: flex;
        position: absolute;
        right: 0;
        width: fit-content;
        margin-top: 5px;
    }

    .fix-margin {
        margin-top: -5px;
    }

    .drawer-card {
        .title {
            color: #f59534;
            font-weight: bold;
        }

        .v-card__text {
            padding: 0px !important;
        }
    }

    .v-tabs {
        box-shadow: none;
        border-bottom: 1px solid #ccc;
        justify-content: space-between;
        display: flex;

        .v-tab {
            color: #757575;
            font-weight: 500;
            text-transform: none;

            &:hover {
                color: #000;
            }

            &.v-tab--active {
                color: #2196f3;
                font-weight: bold;
            }
        }

        .v-tabs-bar {
            border-bottom: none;
        }

        .v-tabs-slider {
            height: 3px;
            background-color: #2196f3;
            border-radius: 2px;
        }
    }

    .group-btns {
        ::v-deep .v-btn__content {
            text-transform: none;
        }

        .active {
            background-color: var(--v-primary-base);
            color: #fff;
            text-transform: none;

            ::v-deep .v-btn__content {
                color: #fff;
                text-transform: none;
            }
        }
    }

    .actions-container {
        position: sticky;
        bottom: 0;
        background-color: white;
        padding: 16px;
        border-top: 1px solid #e0e0e0;
        z-index: 1;
    }
}
</style>
